import { TrackingData } from '@panamax/app-state';

/**
 * CONVERT TO WILL CALL MODAL OPEN
 *
 * @param tracking
 * @returns Data Layer needed for tracking the will call modal open event
 */
export const willCallModalOpen = (tracking: TrackingData) => {
  const result = {
    capability: tracking.data.capability,
    event: tracking.data.event,
    order: {
      id: tracking.data.orderId,
    },
    modal: {
      name: tracking.data.modalName,
    },
    products: tracking.data.products,
  };
  return result;
};
/**
 * CONVERT TO WILL CALL MODAL CLOSE
 *
 * @param tracking
 * @returns Data Layer needed for tracking the will call modal close event
 */
export const willCallModalClose = (tracking: TrackingData) => {
  const result = {
    capability: tracking.data.capability,
    event: tracking.data.event,
    order: {
      id: tracking.data.orderId,
    },
    modal: {
      name: tracking.data.modalName,
    },
    products: tracking.data.products,
  };
  return result;
};

/**
 * SUBMIT CONVERT TO WILL CALL REQUEST
 *
 * @param tracking
 * @returns Data Layer needed for tracking the submit convert to will call request
 */
export const submitConvertToWillCallRequest = (tracking: TrackingData) => {
  const result = {
    capability: tracking.data.capability,
    event: tracking.data.event,
    order: {
      id: tracking.data.orderId,
    },
    modal: {
      name: tracking.data.modalName,
    },
    products: tracking.data.products,
  };
  return result;
};
